import React, { useState } from "react";
import { useEffect } from "react";

const PopupEthicalPledge = props => {
    useEffect(() => {}, []);

    return (
        <div className={props.show ? "pop_ethical-pledge on" : "pop_ethical-pledge"}>
            <div className="pop_base">
                <button type="button" onClick={props.onClose} className="btn_close">
                    닫기
                </button>
                <h2>
                    新 윤리경영 <b>5대 행동원칙 실천 서약</b>
                </h2>
                <h3>『우리는 글로벌1등 기업으로 성장하기 위해 올바른 의사결정과 윤리적 판단으로 회사의 미래를 도모』 한다. 이를 위해 「고객최우선, 준법경영, 기본충실, 주인의식, 사회적 책임」 을 모든 KT MOS인이 공유하고 지켜야 할 윤리경영 5대 행동 원칙으로 삼고, 이를 적극 실천할 것을 서약한다.</h3>
                <div className="list-wrap">
                    <dl>
                        <dt>
                            <b>원칙01.</b> 고객 최우선
                        </dt>
                        <dd>
                            <p>고객을 최우선 가치로 삼는다.</p>
                            <ul>
                                <li>
                                    <em>1</em> 고객의 가치와 정보를 존중하고 철저히 보호한다.
                                </li>
                                <li>
                                    <em>2</em> 고객에게 도움이 되는 차별화된 가치를 끊임없이 창출한다.
                                </li>
                            </ul>
                        </dd>
                    </dl>
                    <dl>
                        <dt>
                            <b>원칙02.</b> 준법경영
                        </dt>
                        <dd>
                            <p>각종 법규와 기준을 엄격히 준수한다.</p>
                            <ul>
                                <li>
                                    <em>1</em> 법과 상도의에 따라 공정하고 깨끗하게 행동한다.
                                </li>
                                <li>
                                    <em>2</em> 경영의 투명성을 확보ㆍ유지하며, 회사의 비밀은 철저히 보호한다.
                                </li>
                            </ul>
                        </dd>
                    </dl>
                    <dl>
                        <dt>
                            <b>원칙03.</b> 기본충실
                        </dt>
                        <dd>
                            <p>기본과 원칙에 충실한다.</p>
                            <ul>
                                <li>
                                    <em>1</em> 회사 전체 이익 관점에서 합리적, 객관적으로 판단하고, 책임 있게 행동한다.
                                </li>
                                <li>
                                    <em>2</em> 공과 사를 엄격히 구분하며, 건전하고 깨끗한 조직문화 조성에 앞장선다.
                                </li>
                            </ul>
                        </dd>
                    </dl>
                    <dl>
                        <dt>
                            <b>원칙04.</b> 주인의식
                        </dt>
                        <dd>
                            <p>스스로 회사와 내가 하나라는 주인의식을 가진다.</p>
                            <ul>
                                <li>
                                    <em>1</em> 실패를 두려워하지 않고, 항상 최고에 도전한다.
                                </li>
                                <li>
                                    <em>2</em> 자율과 임파워먼트를 통해 효율성 향상을 추구한다.
                                </li>
                            </ul>
                        </dd>
                    </dl>
                    <dl>
                        <dt>
                            <b>원칙05.</b> 사회적 책임
                        </dt>
                        <dd>
                            <p>국민기업으로서 사회적 책임과 의무를 다한다.</p>
                            <ul>
                                <li>
                                    <em>1</em> 주주의 권리와 이익을 보호하고, 임직원의 「삶의 질」 향상을 위해 노력한다.
                                </li>
                                <li>
                                    <em>2</em> 환경ㆍ안전ㆍ인권을 중시하고 존중한다.
                                </li>
                                <li>
                                    <em>3</em> 사회공헌 활동에 앞장서고, 사업파트너와 동반성장의 관계를 구축한다.
                                </li>
                            </ul>
                        </dd>
                    </dl>
                </div>
            </div>
        </div>
    );
};

export default PopupEthicalPledge;
